import { PageSpinner } from "@components/layouts/content/PageSpinner";
import PageWithDynamicZoneLayout from "@components/layouts/content/PageWithDynamicZoneLayout";
import ContentComponentSelector from "@modules/content/components";
import { createPageElement } from "@modules/content/creators/createPageElement";
import { usePageData } from "@modules/content/hooks/usePageData";
import { ContentPage } from "@modules/content/types";
import { useIsLoadingVisibile } from "@utils/hooks/useIsLoadingVisible";
import { RamadanBackground } from "./RamadanPage";
import { useState } from "react";
import { useAppLiveQuery } from "@modules/local/hooks";
import { db } from "@modules/local/db";

export interface PrayersDetailsPageParameters {
  thumbnail: string | undefined;
  title: string | undefined;
  types: string | undefined;
}

export const PrayersDetails = createPageElement(({ pageId, context }, ref) => {
  const [selectedCategoryId, setSelectedCategoryId] = useState<string>();

  const { pageData, getParameterValues, isLoading, refresh } =
    usePageData<PrayersDetailsPageParameters>(
      {
        pageId: pageId ?? "",
        context,
      },
      ref
    );

  const { types } = getParameterValues(["types"]);

  const { result: content } = useAppLiveQuery(
    () => db.entities.get(selectedCategoryId || ""),
    [selectedCategoryId]
  );

  if (!pageData || pageData.id !== pageId) {
    return <PrayersDetailsPageLoading isLoading={isLoading} />;
  }

  return (
    <div className="relative flex h-full flex-col items-start justify-start pt-10">
      <RamadanBackground />
      <div className="min-h-[188px] w-[85%]">
        <ContentComponentSelector
          identifier="COM:REPEATED:PRAYERTYPESGRID"
          id={types}
          context={context}
          componentRef={null}
          extraProps={{
            selectedContentId: selectedCategoryId,
          }}
          onItemPress={(content, item) => {
            setSelectedCategoryId(content.id);
          }}
        />
      </div>
      {content && selectedCategoryId ? (
        <PageWithDynamicZoneLayout
          key={selectedCategoryId}
          items={pageData?.dynamicZone ?? []}
          context={content}
          onRefresh={refresh}
          withContext
        ></PageWithDynamicZoneLayout>
      ) : null}
    </div>
  );
});

const PrayersDetailsPageLoading = ({ isLoading }: { isLoading: boolean }) => {
  const isLoadingVisible = useIsLoadingVisibile(isLoading);

  return isLoadingVisible ? <PageSpinner /> : null;
};

export const PrayersDetailsPage: ContentPage = {
  identifier: "PG:PRAYERS:DETAILS",
  page: PrayersDetails,
};
